import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, ListItem, Typography } from "@material-ui/core";
import Icon from "./svg/NextIcon";
import { Link } from "react-router-dom";

import routes from "../../utils/routes.json";
import api from "../../utils/api";


const useStyles = makeStyles({
    item: {
        backgoundColor: "#ffffff",
        borderBottom: "2px solid #bbbbbb",

        display: "flex",
        flexDirection: "row",
        alignItems: "center",

        minHeight: "5rem",
    },
    name: {
        flexGrow: 1,
        textAlign: "center",
    },
    fullWidth: {
        width: "100%",
    },
});

type CategoryItemProps = {
    name: string;
    categoryIds: string[],
    mode: string;
    opponentId: string;
}


export default function CategoryItem({ name, categoryIds, mode, opponentId }: CategoryItemProps): JSX.Element {

    console.log(opponentId);

    const styles = useStyles();
    let path = `${routes.challenge}`;
    if (mode === "practice")
        path = `${routes.practice}`;
    else if (mode === "tournament")
        path = `${routes.tournamentCreator}`;
    else if (mode == "matchfriends")
        path = `${routes.matchfriends}`;

    const sendMatchFriend = (categoryIds: string[]) => {
        api.put("game/matchfriends", {
            user: opponentId,
            message: JSON.stringify({ message: "MatchFriend", "categoryIds": categoryIds.join(",") }),
        });
    };

    const state = mode == "matchfriends" ? { categoryIds: categoryIds, opponentId: opponentId, confirm: false, } : { categoryIds: categoryIds }

    return (
        <Link to={{ pathname: path, state: state }}>
            <Button color="primary" classes={{ root: styles.fullWidth }} onClick={() => {
                if (mode == "matchfriends")
                    sendMatchFriend(categoryIds)
            }}>
                <ListItem button className={styles.item}>
                    <Typography variant="h5" color="primary" className={styles.name}>
                        {name}
                    </Typography>
                    <Icon />
                </ListItem>
            </Button>
        </Link>
    );
}
